
import React, { useRef } from 'react';
import ChatInput from './ChatInput';
import FilePreview from './FilePreview';

interface ChatControlsProps {
  inputMessage: string;
  setInputMessage: (message: string) => void;
  handleSendMessage: (message: string) => void;
  uploadedFiles: File[];
  onRemoveFile: (index: number) => void;
  isUploading: boolean;
  setIsUploading: (value: boolean) => void;
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  renderFilePreview: (file: File) => React.ReactNode;
  showSuggestions?: boolean;
  onPromptClick?: (prompt: string) => void;
}

const ChatControls = ({
  inputMessage,
  setInputMessage,
  handleSendMessage,
  uploadedFiles,
  onRemoveFile,
  isUploading,
  setIsUploading,
  setUploadedFiles,
  renderFilePreview,
  showSuggestions,
  onPromptClick
}: ChatControlsProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsUploading(true);
      setTimeout(() => {
        const newFiles = Array.from(e.target.files || []);
        setUploadedFiles(prev => [...prev, ...newFiles]);
        setIsUploading(false);
      }, 1000);
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="p-4 border-t border-goldcore/10 bg-knightblack/30">
      <FilePreview 
        files={uploadedFiles} 
        onRemove={onRemoveFile} 
        renderFilePreview={renderFilePreview}
        isExpanded={true}
      />
      
      <ChatInput 
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
        handleSendMessage={() => handleSendMessage(inputMessage)}
        triggerFileInput={triggerFileInput}
        isUploading={isUploading}
        onPromptClick={onPromptClick}
        showSuggestions={showSuggestions}
      />
      
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
        multiple
      />
    </div>
  );
};

export default ChatControls;
